import React, { useState } from "react";
import { Card, Button, Alert, Form } from "react-bootstrap";
import { Helmet } from "react-helmet-async";


const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        const data = await response.json();
        setError(data.detail || "Something went wrong");
      }
    } catch (err) {
      setError("Network error");
    }
  };

  return (<><Helmet> <title>Forgot your password? - IndexBooster</title></Helmet>
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Card style={{ width: "400px", padding: "20px" }}>
        <Card.Body>
          <h2 className="text-center mb-4">Forgot your password?</h2>
          {submitted ? (
            <Alert variant="success">
              ✅ Password reset link has been sent to your email.
            </Alert>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Enter your email address</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              {error && <Alert variant="danger">{error}</Alert>}
              <Button type="submit" variant="primary" className="w-100 mt-3">
                Send reset link
              </Button>
              <div className="text-center mt-3">
                <a href="/login">Back to login</a>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </div>
 </> );
};

export default ForgotPassword;
